// @flow

import * as actionTypes from '../../actionTypes/parametersTypes'

const {
  TOGGLE_INITIAL_MOUNT,
  CHANGE_ACTIVE_SORT,
  CHANGE_ERROR_STATE
} = actionTypes

type actionType = {
  type: string,
  activeSort: ?Object,
  view: ?string,
  parameters: ?Object,
  error?: any
}

export default function parametersReducer(
  state: Object = {},
  action: actionType
): Object {
  switch (action.type) {
    case TOGGLE_INITIAL_MOUNT:
      return {
        ...state,
        isNotInitialMount: true
      }
    case CHANGE_ACTIVE_SORT:
      return {
        ...state,
        activeSort: action.activeSort
      }
    case CHANGE_ERROR_STATE:
      return {
        ...state,
        hasError: Boolean(action.error || null),
        error: action.error ? action.error : null
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/shared/reducers/parameters/parameters.js